import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Sidebar, SidebarToggle } from './Sidebar';
import { TopBar } from './TopBar';
import { BackendStatusBanner } from './BackendStatusBanner';
import { AuthGate } from '@/components/auth/AuthGate';
import { useSidebarStore } from '@/stores/sidebarStore';

/**
 * Short one-line context shown in the topbar. The full page title already
 * lives in the sidebar brand, so we only surface a concise "where you are"
 * marker here.
 */
const PAGE_META: Record<string, { title: string; subtitle: string }> = {
  '/':         { title: 'Dashboard',      subtitle: 'Vue d\'ensemble de la plateforme' },
  '/run':      { title: 'Nouvelle campagne', subtitle: 'Sélectionnez un système, une suite et des paramètres' },
  '/live':     { title: 'Suivi en direct', subtitle: 'Logs temps réel de la campagne active' },
  '/history':  { title: 'Historique',     subtitle: 'Archives des campagnes avec filtres' },
  '/sentinel': { title: 'Sentinel',       subtitle: 'Monitoring passif des systèmes Lab' },
  '/tests':    { title: 'Tests',          subtitle: 'Catalogue des tests YAML' },
  '/config':   { title: 'Configuration',  subtitle: 'Paramètres des tests & registre des systèmes' },
  '/suites':          { title: 'Suites',         subtitle: 'Gestionnaire de suites personnalisées' },
  '/help/glossary':   { title: 'Aide · Glossaire', subtitle: 'Définitions des termes techniques de la plateforme et du projet' },
  '/help':            { title: 'Aide',             subtitle: 'Documentation et référence technique' },
};

export function AppShell() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const meta = PAGE_META[pathname] ?? { title: '', subtitle: '' };
  const onLaunch = pathname === '/run' ? undefined : () => navigate('/run');
  const { setCollapsed } = useSidebarStore();

  return (
    <div className="app-shell">
      <a href="#main-content" className="sr-only">Aller au contenu principal</a>
      <Sidebar />
      <SidebarToggle />
      {/* Backdrop mobile : refermé au clic. Toujours rendu dans le DOM ;
       * le CSS le masque hors mobile et hors drawer-ouvert. */}
      <div
        className="sidebar-backdrop"
        aria-hidden
        onClick={() => setCollapsed(true)}
      />
      <div className="app-main">
        {/* Axe 1 audit S++ — bandeau collant si backend down */}
        <BackendStatusBanner />
        <TopBar title={meta.title} subtitle={meta.subtitle} onLaunch={onLaunch} />
        <main id="main-content" tabIndex={-1} style={{ display: 'contents' }}>
          {/* Axe 3 audit S++ — gate auth (transparent si désactivée) */}
          <AuthGate>
            <Outlet />
          </AuthGate>
        </main>
      </div>
    </div>
  );
}
